import { JSON_STRING, MHTTPCL } from "./http/http-client";
import { EXT_REQUEST } from "./common-urls";
import { HttpLib } from "./http/http-lib";

export const BookingRequestService = {
  getData: artist_id =>
    MHTTPCL.get(EXT_REQUEST, {
      section: null,
      action: "hosted",
      artist_id,
      output: JSON_STRING
    }),

  submitBookingRequest: payload =>
    MHTTPCL.post(EXT_REQUEST, {
      action: "booking_request_data_no_promotor",
      ...payload
    }),

  findLocation: term => {
    return HttpLib.get(
      `${MHTTPCL.baseUrl}/request/${MHTTPCL.clientName}/ext_request.pl`,
      {
        params: {
          action: "get_location",
          term
        }
      }
    );
  }
};
